import fieldTranslation from '../../.env.models.json'
import { ClientModel, UserModel } from '@/store/models/UserModel'

export class EntityLoader {
  public static assignDataToUser(
    user: UserModel,
    data: any,
    skipTranslation: boolean
  ) {
    if (!data) {
      return
    }
    let translator: any = {}
    if (!process.env.VUE_APP_MODELS || skipTranslation) {
      Object.assign(user, data)
      return
    }
    if (fieldTranslation) {
      translator = fieldTranslation['User']
    }
    Object.keys(translator).forEach(localFieldName => {
      Object.assign(user, {
        [localFieldName]: data[translator[localFieldName]],
      })
    })
    user.client = new ClientModel(data.client)
  }
}
